export const DATA_LAYER_EVENTS = {
  'gtm.load': 'gtm.load',
  account_drawer: 'account_drawer',
  add_address: 'addressAdded',
  add_collaborator: 'collaboratorAdded',
  add_payment_info: 'paymentInfoAdded',
  add_payment_method: 'paymentMethodAdded',
  add_shipping_info: 'shippingInfoAdded',
  add_to_cart: 'productAdded',
  add_to_wishlist: 'productSaved',
  addedToCartObjectIDs: 'addedToCartObjectIDs',
  addedToCartObjectIDsAfterSearch: 'addedToCartObjectIDsAfterSearch',
  apply_discount: 'discountApplied',
  begin_checkout: 'checkoutStarted',
  brand_promotion_copied: 'brandPromotionCopied',
  brand_promotion_impression: 'brandPromotionImpression',
  brand_promotion_revealed: 'brandPromotionRevealed',
  brandAgentPromptClicked: 'agentPromptClicked ',
  brandAgentQueried: 'agentQueried',
  brandAgentQueryStarted: 'agentQueryStarted',
  brandAgentResponseRated: 'agentResponseRated',
  brandAgentTranscriptSent: 'agentTranscriptSent', // not yet implemented
  carousel: 'carousel',
  change_view: 'viewChanged',
  checkout_started: 'checkoutStarted',
  checkout_step: 'checkout_step',
  checkout_step_completed: 'checkoutStepCompleted',
  checkout_step_viewed: 'checkoutStepViewed',
  choose_location: 'choose_location',
  choose_store_type: 'storeTypeSelected',
  clickedObjectIDs: 'clickedObjectIDs',
  clickedObjectIDsAfterSearch: 'clickedObjectIDsAfterSearch',
  close: 'featureClosed',
  collapse: 'sectionCollapsed',
  colorWallGridClicked: 'colorWallGridClicked',
  comm_opt_in: 'marketingSignUp',
  comm_opt_out: 'marketingOptOut',
  contact_store: 'storeContacted',
  convertedObjectIDsAfterSearch: 'convertedObjectIDsAfterSearch',
  dataLayerLoaded: 'dataLayerLoaded',
  delete_account: 'accountDeleted',
  delete_address: 'addressDeleted',
  download: 'download',
  dsp: {
    join: 'joinProgramClicked',
    expand: 'sectionExpanded',
    collapse: 'sectionCollapsed',
  },
  edit_address: 'addressEditStarted',
  edit_payment_method: 'paymentMethodEditStarted',
  expand: 'sectionExpanded',
  express_checkout_completed: 'expressCheckoutCompleted',
  express_checkout_viewed: 'expressCheckoutViewed',
  amazon_pay_checkout_viewed: 'amazonPayCheckoutViewed',
  amazon_pay_checkout_completed: 'amazonPayCheckoutCompleted',
  failed_discount: 'discountFailed',
  filter: 'filter',
  filterApplied: 'filterApplied',
  filterRemoved: 'filterRemoved',
  find_product: 'find_product',
  friction: 'friction',
  initiate_delete_account: 'deleteAccountStarted',
  lightSelected: 'lightSelected',
  location_entered: 'locationEntered',
  login: 'userLoggedIn',
  login_authentication: 'login_authentication',
  notify_me: 'notify_me',
  open: 'featureOpened',
  order_history: 'order_history',
  order_success: 'orderCompleted',
  product_image_carousel_changed: 'productImageCarouselChanged',
  product_impression: 'productImpression',
  product_learn_more_clicked: 'productLearnMoreClicked',
  product_notification_clicked: 'productNotificationClicked',
  purchase: 'orderCompleted',
  purchasedObjectIDs: 'purchasedObjectIDs',
  purchasedObjectIDsAfterSearch: 'purchasedObjectIDsAfterSearch',
  refund: 'orderRefunded',
  remove_collaborator: 'collaboratorRemoved',
  remove_discount: 'discountRemoved',
  remove_from_cart: 'productRemoved',
  save_address: 'addressSaved',
  save_look: 'sceneSaved',
  save_payment_method: 'paymentMethodSaved',
  search: 'searchInitiated',
  search_bar_opened: 'searchBarOpened',
  search_cleared: 'searchCleared',
  search_refinement: 'searchRefined',
  sampleSizeSelected: 'sampleSizeSelected',
  sectionCollapsed: 'sectionCollapsed',
  sectionExpanded: 'sectionExpanded',
  select_content: 'contentSelected',
  select_item: 'productCardClicked',
  select_promotion: 'promotionSelected',
  select_store: 'storeSelected',
  send_message: 'messageSent',
  share: 'share',
  sign_up: 'accountCreated',
  sign_up_authentication: 'accountCreationStepViewed',
  sign_up_email: 'accountCreationStepViewed',
  sign_up_name: 'accountCreationStepViewed',
  sign_up_phone: 'accountCreationStepViewed',
  sign_up_resend_auth: 'accountCreationStepViewed',
  sign_up_role: 'sign_up_role',
  sign_up_start: 'accountCreationStarted',
  update_account: 'accountUpdated',
  update_address: 'addressUpdated',
  upload: 'upload',
  userParamsLoaded: 'userParamsLoaded',
  view_account_settings: 'view_account_settings',
  view_addresses: 'view_addresses',
  view_cart: 'cartViewed',
  view_item: 'productViewed',
  view_item_list: 'productListViewed',
  view_order_history: 'view_order_history',
  view_payment_methods: 'view_payment_methods',
  view_promotion: 'promotionViewed',
  view_search_results: 'searchResultsViewed',
  virtual_page_view: 'virtual_page_view',
  viz_impression: 'visualizerProductImpression',
  w2b_conv: 'w2bConverted',
  w2b_open: 'w2b_open',
} as const;

export type DataLayerEvents = (typeof DATA_LAYER_EVENTS)[keyof typeof DATA_LAYER_EVENTS];
